export function isForwardReference(module) {
  return module != null && module.forwardRef != null;
}
export function isDynamicModule(module) {
  return module != null && module.module != null;
}
export function isClassProvider(p) {
  return (p === null || p === void 0 ? void 0 : p.useClass) != null;
}
export function isValueProvider(p) {
  return (p === null || p === void 0 ? void 0 : p.useValue) != null;
}
export function isFactoryProvider(p) {
  return (p === null || p === void 0 ? void 0 : p.useFactory) != null;
}